export default __webpack_public_path__ + "static/media/CSRealCase1-moblie.88707a75.jpg";